module.exports = __webpack_public_path__ + "img/3537602b-54b1-4968-90c2-0e55e48c8027.d8b6c4bd.png";